var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualLookupNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80078 16.2008L1.80108 13.5005C1.80125 12.0094 3.01003 10.8008 4.50108 10.8008H9.45078M12.6008 11.3794L14.4008 9.45078M14.4008 9.45078L16.2008 11.3794M14.4008 9.45078V14.4008M13.0508 1.80078C14.143 2.41299 14.8508 3.39444 14.8508 4.50078C14.8508 5.60712 14.143 6.58857 13.0508 7.20078M10.8008 4.50078C10.8008 5.99195 9.59195 7.20078 8.10078 7.20078C6.60961 7.20078 5.40078 5.99195 5.40078 4.50078C5.40078 3.00961 6.60961 1.80078 8.10078 1.80078C9.59195 1.80078 10.8008 3.00961 10.8008 4.50078Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualLookupNav);
export default __webpack_public_path__ + "static/media/individual-lookup-nav.65d3d07bf7678c153dc39b38290d35be.svg";
export { ForwardRef as ReactComponent };